import type { QueryMatch, SyntaxNode } from 'web-tree-sitter';
import type { CodeNavYieldState } from '../yield-during-work.js';
import { yieldDuringCodeNavWork } from '../yield-during-work.js';
import type { SymbolTag } from '../types.js';
import { tagsFromMatches } from './tags-from-matches.js';

function tagDedupeKey(tag: SymbolTag): string {
  return `${tag.startLine}:${tag.startColumn}:${tag.endLine}:${tag.endColumn}:${tag.role}:${tag.kind}:${tag.name}`;
}

/** Process one match at a time so tag extraction can yield to the event loop. */
export async function tagsFromMatchesAsync(
  matches: QueryMatch[],
  state: CodeNavYieldState,
): Promise<{ tags: SymbolTag[]; nameNodes: Map<string, SyntaxNode> }> {
  const tags: SymbolTag[] = [];
  const nameNodes = new Map<string, SyntaxNode>();
  const seen = new Set<string>();

  for (const match of matches) {
    await yieldDuringCodeNavWork(state);
    const partial = tagsFromMatches([match]);
    for (const tag of partial.tags) {
      const key = tagDedupeKey(tag);
      if (seen.has(key)) continue;
      seen.add(key);
      tags.push(tag);
    }
    for (const [key, node] of partial.nameNodes) nameNodes.set(key, node);
  }

  return { tags, nameNodes };
}
